// OrgChartConnectors — one SVG layer of orthogonal parent→children lines: a
// stem from the parent's bottom to a horizontal bus, then a drop into each
// child, with tone-colored dot terminals at every junction.

import { getLevel } from '@/mocks/structure';
import { ChartLayout, V_GAP } from './orgChartLayout';

interface OrgChartConnectorsProps {
  layout: ChartLayout;
}

const OrgChartConnectors = ({ layout }: OrgChartConnectorsProps) => {
  const segs: string[] = [];
  const dots: { x: number; y: number; tone: string }[] = [];

  layout.nodes.forEach((p) => {
    const kids = layout.edges.filter((e) => e.from.id === p.id).map((e) => e.to);
    if (!kids.length) return;
    const pB = p.y + p.h;
    const busY = pB + V_GAP / 2;
    segs.push(`M ${p.cx} ${pB} L ${p.cx} ${busY}`);
    const xs = kids.map((k) => k.cx);
    segs.push(`M ${Math.min(...xs)} ${busY} L ${Math.max(...xs)} ${busY}`);
    kids.forEach((k) => segs.push(`M ${k.cx} ${busY} L ${k.cx} ${k.y}`));
    dots.push({ x: p.cx, y: pB, tone: getLevel(p.node.level).tone });
    kids.forEach((k) => dots.push({ x: k.cx, y: k.y, tone: getLevel(k.node.level).tone }));
  });

  return (
    <svg className='org-chart__connectors' width={layout.width} height={layout.height}>
      {segs.map((d, i) => (
        <path
          key={i}
          className='org-chart__edge'
          d={d}
          strokeWidth={2}
          fill='none'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      ))}
      {dots.map((d, i) => (
        <circle
          key={i}
          className={`org-chart__dot org-chart__dot--${d.tone}`}
          cx={d.x}
          cy={d.y}
          r={5}
          strokeWidth={2.5}
        />
      ))}
    </svg>
  );
};

export default OrgChartConnectors;
